export function imageUploadHelperTextWithAspectRatio(dimensions) {
  let fileTypesString = "";
  if (dimensions.validate_file_type && dimensions.required_file_type) {
    fileTypesString = dimensions.required_file_type.toUpperCase().split(",").join("/");
  }
  let fileSizeString = "";
  if (dimensions.max_file_size && dimensions.validate_file_size) {
    fileSizeString = ` Max ${dimensions.max_file_size}MB.`;
  }

  const dimensionString = `Min ${dimensions.min_width}x${dimensions.min_height} ${fileTypesString} with same aspect ratio required.`;
  return `${dimensionString}${fileSizeString}`;
}
